<div class="header">
    <!--<h1>{{ title }}</h1>
    <h2>{{ subtitle }}</h2>-->
    <ul class='nav navbar-nav' *ngIf="items.length > 0">
        <li [routerLinkActive]="['link-active']" *ngFor="let item of items">
            <a [routerLink]="['/' + item.path]">
                <mat-icon>{{item.icon}}</mat-icon> <span style="vertical-align: middle; margin-left: 5px;">{{'turbo.app.mnu_' + item.path | translate: item.title}}</span>
            </a>
        </li>
    </ul>
    <mat-toolbar [ngStyle]="{'display': (contentWrapper?.children?.length > 0) ? 'block' : 'none', 'border-top': (contentWrapper?.children?.length > 0 && items.length > 0) ? '1px solid #d7dee4' : '0'}" style="width: calc(100% + 20px); margin-left:-10px;">
      <div #contentWrapper style="height: 100%; box-sizing: border-box;padding: 0;width: 100%;flex-direction: row;align-items: center;white-space: nowrap;">
        <ng-content></ng-content>
        <ng-container *ngIf="false">
          <span class="t4change-spinner-wrapper">
            <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
          </span>
          <span class="t4change-progress-text">
            Meddelande...
          </span>
        </ng-container>
      </div>
    </mat-toolbar>
</div>
